import { useOidcStore } from "vue3-oidc";
import { renewAfterUnauthorized } from "@/setup/oidcSessionRecovery";

const currentToken = () => useOidcStore().state.value.token;

// Renouvelle la session et renvoie le nouveau jeton, ou null s'il n'a pas changé.
const renewedToken = async (rejectedToken) => {
  if (currentToken() === rejectedToken) await renewAfterUnauthorized();
  const token = currentToken();
  return token && token !== rejectedToken ? token : null;
};

const bearerOf = (authorization) =>
  String(authorization ?? "").replace(/^Bearer\s+/i, "");

export const retryAxiosOnUnauthorized = (client) => {
  client.interceptors.response.use(undefined, async (error) => {
    const { config, response } = error;
    if (response?.status !== 401 || !config || config.isRetryAfterRenewal)
      throw error;

    const token = await renewedToken(bearerOf(config.headers?.Authorization));
    if (!token) throw error;

    config.isRetryAfterRenewal = true;
    config.headers.Authorization = `Bearer ${token}`;
    return client.request(config);
  });
};

// Middleware des SDK OpenAPI (typescript-fetch). Le rejeu passe par le fetch
// natif pour ne pas repasser dans ce middleware.
export const unauthorizedRetryMiddleware = {
  async post({ url, init, response }) {
    if (response.status !== 401) return response;

    const headers = new Headers(init.headers);
    const token = await renewedToken(bearerOf(headers.get("Authorization")));
    if (!token) return response;

    headers.set("Authorization", `Bearer ${token}`);
    return globalThis.fetch(url, { ...init, headers });
  },
};
